import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {type ILabelValue} from '@netx/core-next/schema/common';
import {type IAssetAutoListItem} from '../schema';

/**
 * `getAssetAutoList` request params
 * (what is used to send to server)
 */
export interface GetAssetAutoListRequestOptions {
	query: string;
}

/**
 * `getAssetAutoList` request
 * (what gets sent to the server)
 */
export type GetAssetAutoListRequest = [GetAssetAutoListRequestOptions['query']];

/**
 * `getAssetAutoList` response
 * (what comes back from the server)
 */
export type GetAssetAutoListResponse = SuccessResponse<ILabelValue[]>;

/**
 * `getAssetAutoList` result
 * (what is utilized from the server response)
 */
export type GetAssetAutoListResult = IAssetAutoListItem[];

export const getAssetAutoListEndpoint = 'getAssetAutoList';

/**
 * Autolist assets
 * @param fetchParams Fetch params
 */
export const getAssetAutoList = async (
	{query}: GetAssetAutoListRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetAssetAutoListRequest = [query];

	return client
		.post<GetAssetAutoListResponse>(getAssetAutoListEndpoint, requestParams, {
			signal,
		})
		.then((response) =>
			response.data.result.map<IAssetAutoListItem>((d) => ({
				...d,
				value: parseInt(d.value),
			})),
		);
};
export default getAssetAutoList;
